import { createContext } from 'react'

const PWAInstallContext = createContext<BeforeInstallPromptEvent>(null)
export default PWAInstallContext
